/**
 * Created by Nomy on 08/08/2017.
 */
"use strict";

class DeveloperLeadsController {
    constructor($scope, $window, $timeout, $localStorage, SSHttpService, SSUtilService, SSAppService, SSUserService, SSAlertService) {

        const self = this;

        self.$scope = $scope;
        self.$window = $window;
        self.$timeout = $timeout;
        self.$storage = $localStorage;

        self.SSHttpService = SSHttpService;
        self.SSUtilService = SSUtilService;
        self.SSAppService = SSAppService;
        self.SSUserService = SSUserService;
        self.SSAlertService = SSAlertService;

        self.leads = null;
        self.properties = null;
        self.buyers = null;
        self.units = null;
        self.leads = null;
        self.readLeadsCount = null;
        self.allLeads = null;
        self.leadsFiltered = null;
        self.newLeads = null;
        self.newLeadsCount = null;
        self.newLeadsFiltered = null;
        self.showNumberOfNewLeads = 5;
        self.showNumberOfAllLeads = 5;
        self.showNumberOfTransferredLeads = 5;
        self.filteredAll = false;
        self.filteredNew = false;
        self.filteredTransferred = false;
        self.newLeadsMenu = "All Projects";
        self.leadsMenu = "All Projects";
        self.readAsMarks = [];
        self.searchVal = '';
        self.offset = 0;
        self.limit = 5;

        self.new_lead_filter = 1;
        self.lead_filter = 2;
        self.transferred_lead_filter = 3;
        self.selectedLeadTab = self.new_lead_filter;

        self.BUYER_TYPE_INDIVIDUAL = SHOWSUITE.BUYER_TYPE_INDIVIDUAL;
        self.BUYER_TYPE_COMPANY = SHOWSUITE.BUYER_TYPE_COMPANY;

        self.BUYER_ENQUIRY_TYPE_DEVELOPER = SHOWSUITE.BUYER_ENQUIRY_TYPE_DEVELOPER;

        self.BUYER_ENQUIRY_STATUS_CREATED = SHOWSUITE.BUYER_ENQUIRY_STATUS_CREATED;
        self.BUYER_ENQUIRY_STATUS_VERIFIED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VERIFIED;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT;
        self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY = SHOWSUITE.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY;
        self.BUYER_ENQUIRY_STATUS_VIEWED = SHOWSUITE.BUYER_ENQUIRY_STATUS_VIEWED;

        if (self.SSUserService.isDeveloper()) {
            self.init();
        }
    }

    init() {
        const self = this;
        loading(true);
        self.getLeads();
        self.getTransferredLeads();
        self.getDeveloper();

        self.searchValue = 0;
        self.searchValueLeads = 0;
        self.developerAgencies = {};
    }

    getDeveloperAgencies(property_id){
        const self = this;

        let url = 'sec/developer/agencies/';
        let params ={
            'property_id': property_id
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            if(response.data.property_agencies.length > 0){
                self.developerAgencies[response.data.property_agencies[0].property_id] = response.data.property_agencies[0];
            }
        });
    }

    getLeads() {
        const self = this;
        self.leads = [];
        let url = 'sec/developer/leads';
        let params = {
            offset: self.offset,
            limit: self.limit,
            order: '{"updated_at":"desc"}'
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            if (response.data.leads) {
                self.leads = response.data.leads;
                self.allLeads = self.leads;
                self.projectsOfAllLeads = response.data.projects;
                self.properties = response.data.properties;
                self.units = response.data.units;
                self.buyers = response.data.buyers;
                self.newLeadsCount = response.data.newLeadsCount;
                self.readLeadsCount = response.data.readLeadsCount;
                self.getNewLeads(self.leads);
                self.markAsRead();

                let propertyIds = [];
                $.each(self.properties, function(index, property){
                    if(!_.includes(propertyIds, property.id)){
                        propertyIds.push(property.id);
                        self.getDeveloperAgencies(property.id);
                    }
                });

                //Arrange transferred lead obj into leads
                self.arrangeTransferredLeadIntoLeads(response.data.transferred_leads);

                self.$timeout(function() { $("select.dashboard-select#project-select").niceSelect('update'); });
            }
        });
    }

    isDeleteButtonAllowed(leadId){
        const self = this;
        let check = false;

        let buyerEnquiryStatus = [self.BUYER_ENQUIRY_STATUS_CREATED, self.BUYER_ENQUIRY_STATUS_VERIFIED,
            self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENT, self.BUYER_ENQUIRY_STATUS_ASSIGNED_TO_AGENCY,
            self.BUYER_ENQUIRY_STATUS_VIEWED];

        $.each(self.leads, function(index, lead){

            if(lead.id == leadId){
                //check type 20
                if(lead.type == self.BUYER_ENQUIRY_TYPE_DEVELOPER){
                    //check if same user developer
                if(buyerEnquiryStatus.includes(lead.status)
                    && lead.developer_id == self.developer.id
                    && !lead.broker_user_id
                    && !lead.agency_id){
                    check = true;
                    return;
                    }
                }
            }
        });

        return check;
    }

    getDeveloper() {
        const self = this;

        let url = 'sec/developer/profile';

        loading(true);
        self.SSHttpService.getAPIRequest(url).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            self.developer = response.data.developer;
        });
    }

    isTransferAllowed(property_id){
        const self = this;

        if(self.developerAgencies[property_id]){
            return true;
        }
        else{
            return false;
        }
    }

    getNewLeads(leads) {
        const self = this;
        self.newLeads = _.filter(leads, function (lead) {
            if (lead.read_status == 0) {
                return lead;
            }
        });
        self.getFiveAsRead(self.newLeads);
        self.leads = _.filter(leads, function (lead) {
            if (lead.read_status == 1) {
                return lead;
            }
        });

    }

    showMoreLeads(leadsType) {
        const self = this;

        self.limit = self.limit + 5;
        let url = 'sec/developer/leads';
        let params = {
            offset: self.offset,
            limit: self.limit,
            leadsType: leadsType
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            if (response.data.leads) {
                if (leadsType == 'new') {
                    self.newLeads = [];
                    self.newLeads = response.data.leads;
                    self.markAsRead();
                }
                if (leadsType == 'read') {
                    self.leads = [];
                    self.leads = response.data.leads;
                }
                self.projectsOfAllLeads = response.data.projects;
                self.properties = response.data.properties;
                self.units = response.data.units;
                self.buyers = response.data.buyers;

                //Arrange transferred lead obj into leads
                self.arrangeTransferredLeadIntoLeads(response.data.transferred_leads);
            }
        });
    }

    addFiveMore(count) {
        const self = this;
        count = count + 5;
        return count;
    }

    showMoreNewLeads() {
        const self = this;
        self.showNumberOfNewLeads = self.addFiveMore(self.showNumberOfNewLeads);

        if (self.newLeadsFiltered) {
            self.getFiveAsRead(self.newLeadsFiltered);
            self.markAsRead();
        }
        else {
            self.getFiveAsRead(self.newLeads);
            self.markAsRead();
        }

    }

    showMoreAllLeads() {
        const self = this;
        self.showNumberOfAllLeads = self.addFiveMore(self.showNumberOfAllLeads);
    }

    showMoreTransferredLeads() {
        const self = this;
        self.showNumberOfTransferredLeads = self.addFiveMore(self.showNumberOfTransferredLeads);
    }

    getMoreTransferredLeads() {
        const self = this;

        self.transferred_limit = self.transferred_limit + 5;
        let url = 'sec/developer/leads/transferred';
        let params = {
            offset: self.transferred_offset,
            limit: self.transferred_limit,
        };
        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);
            if (response instanceof Error) {
                return;
            }
            if (response.data.transferred_leads) {
                self.transferredLeads = [];
                self.transferredLeads = response.data.transferred_leads;
                self.projects_transferred = response.data.projects;
                self.buyers_transferred = response.data.buyers;
                self.properties_transferred = response.data.properties;
                self.units_transferred = response.data.units;
            }
        });
    }

    searchProjectsLeads(filter_type = 1){
        const self = this;

        let property_id = self.searchValueLeads;
        if(!property_id){
            self.filterProjects(0, null, filter_type);
        }
        else{
            let property = null;
            if (filter_type == self.transferred_lead_filter) {
                property =  self.projects_transferred[property_id];
            } else {
                property =  self.projectsOfAllLeads[property_id];
            }
            self.filterProjects(property_id, property.name, filter_type);
        }

        self.$timeout(function() { $("select.dashboard-select#project-select").niceSelect('update'); });
    }

    searchProjects(filter_type = 1){
        const self = this;

        let property_id = self.searchValue;
        if(!property_id){
            self.filterProjects(0, null, filter_type);
        }
        else{
            let property = null;
            if (filter_type == self.transferred_lead_filter) {
                property =  self.projects_transferred[property_id];
            } else {
                property =  self.projectsOfAllLeads[property_id];
            }
            self.filterProjects(property_id, property.name, filter_type);
        }

        self.$timeout(function() { $("select.dashboard-select#project-select").niceSelect('update'); });
    }

    filterProjects(property_id, property_name, filter_type = 1) {
        const self = this;

        let leads = '';

        switch (filter_type) {
            case self.new_lead_filter:
                self.newLeadsMenu = (property_name == null) ? 'All Projects' : property_name;
                self.filteredNew = true;
                self.newLeadsFiltered = '';
                leads = _.filter(self.newLeads, function (lead) {
                    if (lead.property_id == property_id) {
                        return lead;
                    }
                });
                if (property_name == null) {
                    leads = self.newLeads;
                }
                self.newLeadsFiltered = leads;
                self.getFiveAsRead(self.newLeadsFiltered);
                self.markAsRead();
                break;
            case self.lead_filter:
                self.leadsMenu = (property_name == null) ? 'All Projects' : property_name;
                self.filteredAll = true;
                self.leadsFiltered = '';

                leads = _.filter(self.leads, function (lead) {
                    if (lead.property_id == property_id) {
                        return lead;
                    }
                });
                if (property_name == null) {
                    self.filteredAll = false;
                    leads = self.leads;
                }
                self.leadsFiltered = leads;
                break;
            case self.transferred_lead_filter:
                self.leadsMenu = (property_name == null) ? 'All Projects' : property_name;
                self.filteredTransferred = true;
                self.transferredLeadsFiltered = '';

                leads = _.filter(self.transferredLeads, function (lead) {
                    if (lead.lead.property_id == property_id) {
                        return lead;
                    }
                });
                if (property_name == null) {
                    self.filteredTransferred = false;
                    leads = self.transferredLeads;
                }
                self.transferredLeadsFiltered = leads;
                break;

            default:
                console.log("Invalid filter type!");
        }
    }

    getFiveAsRead(leads) {
        const self = this;
        let i = 1;
        self.readAsMarks = [];
        _.filter(leads, function (lead) {
            if (i <= self.showNumberOfNewLeads) { //Fetching 5 records to mark as read
                self.readAsMarks.push(lead.id);
            }
            i++;
        });

    }

    markAsRead() {
        const self = this;
        // return;
        let url = 'sec/developer/leads/mark-as-read';
        if (self.readAsMarks.length == 0)
            return;
        //let params= {data:self.readAsMarks};
        let params = {data: self.readAsMarks};
        //console.log(params);
        self.SSHttpService.postAPIRequest(url, params).then(function (response) {
            //console.log(response);
            if (response instanceof Error) {
                return;
            }
            if (response.success) {
                //alert(response.success);
                return;

            }
        });
    }

    buildSearchVal(val) {
        const self = this;
        if (val && startsWith(val, '#')) {
            val = val.split('#');
            val = val[1];
        }

        if (val && val.toString().length == 1) {
            val = '0' + val;
        }
        val = '#' + val;
        return val;
    }

    searchFilter() {
        const self = this;
        self.searchVal = self.searchVal.toString().toLowerCase();
        if (self.searchVal == '0' || self.searchVal == '#' || self.searchVal == '#0') {
            return;
        }
        if (self.searchVal == '') {
            self.getLeads();
        }
        let usersArray = _.filter(self.buyers, function (user) {
            if (startsWith(user['display_name'].toLowerCase(), self.searchVal) || startsWith(user['first_name'].toLowerCase(), self.searchVal) || startsWith(user['last_name'].toLowerCase(), self.searchVal) || startsWith(user['email'].toLowerCase(), self.searchVal)) {
                return user;
            }
        });
        let unitArray = _.filter(self.units, function (unit) {

            let buildUnitNo = '';
            let buildSearchVal = '';
            buildUnitNo = self.SSUtilService.getUnitNumber(unit, false);
            buildSearchVal = self.buildSearchVal(self.searchVal);
            //console.log(buildUnitNo);
            //console.log(buildSearchVal);
            if (startsWith(buildUnitNo, buildSearchVal)) {
                return unit;
            }

        });
        //console.log(self.leads);
        //console.log(unitArray);

        //##########New Leads########
        let newLeads = [];
        if (self.filteredNew) {
            self.newLeads = self.newLeadsFiltered;
        }
        _.each(self.newLeads, function (lead) {
            _.each(unitArray, function (ele) {
                if (lead.unit_id == ele.id) {
                    newLeads.push(lead);
                }
            });
        });
        _.each(self.newLeads, function (lead) {
            _.each(usersArray, function (ele) {
                if (lead.buyer_id == ele.id) {
                    newLeads.push(lead);
                }
            });
        });

        if (self.filteredNew) {
            self.newLeadsFiltered = newLeads;
        }
        else {
            self.newLeads = newLeads;
        }

        let leads = [];

        if (self.filteredAll) {
            self.leads = self.leadsFiltered;
        }
        _.each(self.leads, function (lead) {
            _.each(unitArray, function (ele) {
                if (lead.unit_id == ele.id) {
                    leads.push(lead);
                }
            });
        });
        _.each(self.leads, function (lead) {
            _.each(usersArray, function (ele) {
                if (lead.buyer_id == ele.id) {
                    leads.push(lead);
                }
            });
        });
        if (self.filteredAll) {
            self.leadsFiltered = leads;
        }
        else {
            self.leads = leads;
        }
    }

    onDelete(lead_id){
        const self = this;

        self.hideModal();
        self.delete_lead_id = lead_id;
        self.showModal = true;
        $('#confirmDeleteLeadModal').modal('show');
    }

    onDeleteConfirmation(){
        const self = this;

        self.hideModal();
        let url = 'sec/developer/leads/' + parseInt(self.delete_lead_id) + '/delete-lead';

        loading(true);
        self.SSHttpService.postAPIRequest(url).then(function (response) {
            loading(false);
            if (response instanceof Error) {
              self.SSAlertService.parseAndDisplayError(response);
              return;
            }
            self.SSAlertService.success('Success!', 'Lead deleted successfully');
            // Refresh the page
            self.$window.location.href = '/developer/leads';
        });
    }

    hideModal() {
        const self = this;

        self.showModal = false;
        self.showBuyerInformationModal = false;

        if ($('#confirmDeleteLeadModal').is(':visible')) $('#confirmDeleteLeadModal').modal('hide');
        if ($('#buyerInformationModal').is(':visible')) $('#buyerInformationModal').modal('hide');
    }

    getTransferredLeads() {
        const self = this;

        self.transferredLeads = null;
        self.transferredLeadsCount = null;
        self.transferredLeadsFiltered = null;

        self.transferred_offset = 0;
        self.transferred_limit = 5;

        let url = 'sec/developer/leads/transferred';
        let params = {
            offset: self.transferred_offset,
            limit: self.transferred_limit,
            order: '{"updated_at":"desc"}'
        };

        loading(true);
        self.SSHttpService.getAPIRequest(url, params).then(function (response) {
            loading(false);

            if (response instanceof Error) {
                self.SSAlertService.parseAndDisplayError(response);
                return;
            }

            if (response.data.transferred_leads) {
                self.transferredLeads = response.data.transferred_leads;
                self.transferredLeadsCount = response.data.transferred_leads_count;
                self.projects_transferred = response.data.projects;
                self.buyers_transferred = response.data.buyers;
                self.properties_transferred = response.data.properties;
                self.units_transferred = response.data.units;

                self.$timeout(function() { $("select.dashboard-select#project-select").niceSelect('update'); });

            }
        });
    }

    arrangeTransferredLeadIntoLeads(transferred_leads) {
        const self = this;

        $.each(transferred_leads, function(index, transferred_lead) {
            let found_lead = self.leads.find(x => x.id == transferred_lead.buyer_enquiry_id);

            if (found_lead) {
                found_lead.transferred_lead = transferred_lead;
            }
        });
    }

    viewBuyerInformation(customer_obj) {
        const self = this;

        self.viewBuyerObj = customer_obj;

        //Add to Firebase Analytics Event
        firebase.analytics().logEvent('LD_DMS_VW_BUYER', {'event_category': 'Developer Lead'});

        self.hideModal();
        self.showBuyerInformationModal = true;
        $('#buyerInformationModal').modal('show');
    }

    toggleLeadMessageSection(lead) {
        let div = $('#notification-message-lead-' + lead.id);

        if (lead.display_message_section) {
            div.slideUp(400);
        } else {
            div.slideDown(400);
        }

        lead.display_message_section = !lead.display_message_section;
    }
}

DeveloperLeadsController.$inject = ['$scope', '$window', '$timeout', '$localStorage', 'SSHttpService', 'SSUtilService', 'SSAppService', 'SSUserService', 'SSAlertService'];
app.controller('DeveloperLeadsController', DeveloperLeadsController);

